import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

const ConfirmReservationPage = () => {
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(true);
  const [statusMessage, setStatusMessage] = useState("");

  useEffect(() => {
    const varausID = searchParams.get("varausID");
    if (!varausID) {
      setStatusMessage("Varaus ID puuttuu linkistä.");
      setLoading(false);
      return;
    }

    const confirmReservation = async () => {
      try {
        const response = await fetch("https://spiderlegsproductions.com/api/confirm_reservation.php", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ varausID: parseInt(varausID) })
        });

        const result = await response.json();
        if (result.success) {
          setStatusMessage("Kiitos! Varaus on nyt vahvistettu.");
        } else {
          setStatusMessage(result.message || "Varausta ei voitu vahvistaa.");
        }
      } catch (error) {
        console.error("Virhe vahvistuksessa:", error);
        setStatusMessage("Palvelinvirhe. Yritä hetken päästä uudelleen.");
      } finally {
        setLoading(false);
      }
    };

    confirmReservation();
  }, [searchParams]);

  return (
    <div className="min-h-screen flex flex-col justify-center items-center bg-linkcol dark:bg-violet dark:bg-opacity-75 text-white p-8">
      <h1 className="font-customFont2 text-darkest dark:text-primary dark:text-shadow-lg text-5xl font-bold mb-4">Varausvahvistus</h1>
      {loading ? (
        <p>Vahvistetaan varausta...</p>
      ) : (
        <p className="font-customFont1 text-darkest dark:text-primary dark:text-shadow-lg text-lg text-center max-w-md">{statusMessage}</p>
      )}
    </div>
  );
};

export default ConfirmReservationPage;